import { Pipe, PipeTransform } from '@angular/core';
import { Filter, GroupMultiSelectFilter } from '@models/filter-types';
import { isGroupMultiSelectFilter } from '@shared/helpers/functions/helpers';

@Pipe({
    name: 'isGroupMultiselectFilter',
    standalone: false,
})
export class IsGroupMultiselectFilterPipe implements PipeTransform {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    transform(value: Filter<any>): value is GroupMultiSelectFilter<any> {
        return isGroupMultiSelectFilter(value);
    }
}
